import type { FeedRow } from "@/models/feed/feedRows";

/** A message row before measurement: sender line, a card with the Listen button and a short transcript, receipts. */
export const FEED_ITEM_ROW_ESTIMATE_PX = 140;

/**
 * A message row carrying a display artifact before measurement: a fleet message's title, its description collapsed
 * to the transcript's maximum height, the "Show full transcription" button, and receipts.
 */
export const FEED_ARTIFACT_ROW_ESTIMATE_PX = 200;

/** A TMS event chip row before measurement: one chip and its spacing. */
export const TMS_EVENT_ROW_ESTIMATE_PX = 56;

/** A date header row before measurement: `FeedItemHeader` is a fixed 34px with no vertical margins. */
export const DATE_HEADER_ROW_ESTIMATE_PX = 34;

/**
 * How tall an unmeasured feed row is assumed to be, by what the row is.
 *
 * The virtualizer lays out rows it has never rendered at this size and corrects the scroll by the difference once
 * each one is measured, so a chip estimated at a message's height, or a message at a flat guess far from its real
 * height, reads as a jump while scrolling back. One estimate per row kind keeps those corrections small; a message
 * with a display artifact is the one kind of item row that is reliably taller than the rest.
 */
export function estimateFeedRowSize(row: FeedRow): number {
  switch (row.type) {
    case "dateHeader":
      return DATE_HEADER_ROW_ESTIMATE_PX;
    case "tmsEvent":
      return TMS_EVENT_ROW_ESTIMATE_PX;
    case "item":
      return row.item.displayArtifact ? FEED_ARTIFACT_ROW_ESTIMATE_PX : FEED_ITEM_ROW_ESTIMATE_PX;
  }
}
